<template>
	<div class="bidding-system" v-if="Cdstatus">
		<!-- 头部导航栏 -->
		<Header class="headerBox"></Header>


		<!-- 导航栏 -->
		<div class="left-navigation" :class="isCollapse ? '' : 'left-navigation-isCollapse'">
			<!-- <treeNode :tabList="tabList" /> -->
			<!-- <el-menu default-active="2" class="el-menu-vertical-demo"  @close="handleClose" -->
			<!-- :collapse="!isCollapse"> -->
			<!-- <el-radio-group v-model="isCollapse" style="">
        <el-radio-button :label="true">展开</el-radio-button>
        <el-radio-button :label="false">收起</el-radio-button>
      </el-radio-group> -->

			<!-- <treeNode :tabList="tabList" @menuItemClick="handleOpendw" ref="DtreeNode" /> -->
			<!-- :unique-opened="true" -->
			<el-menu :default-active="defaultActive" class="el-menu-vertical-demo" @open="handleOpen">
				<div class="el-menu-vertical-demo-item" v-for="(item, index) in tabList" :key="item.id">
					<treeNode :navIndex="index" :item="item" @menuItemClick="handleOpendw" @xialkuang="xialkuang">
					</treeNode>
				</div>
			</el-menu>

			<!-- </el-menu> -->
		</div>
		<div v-if="currentView != ''" class="right-page" :class="isCollapse ? '' : 'right-page-isCollapse'">
			<component :is="currentView" :GtsData="GtsData" :locationData="locationData" :useriTtem="useriTtem"
				:key="datekey"></component>
			<div class="beian" @click="skipClick">@Copyright 健康监护平台 | 苏ICP备2022040978号-1</div>

		</div>
		<div v-else>

			<div class="beijing-img">
				<div class="beijing-beian" @click="skipClick">@Copyright 健康监护平台 | 苏ICP备2022040978号-1</div>

			</div>


		</div>
		<!-- <div class="right-page" :class="isCollapse ? '' : 'right-page-isCollapse'" v-if=" JSON.stringify(locationData) != ''">
      <component :is="currentView" :locationData="locationData"></component>
    </div> -->
	</div>
</template>


<script>
	import Header from './header/index.vue'
	import {
		setSystemUserTree,
		deviceUserDevice
	} from '@/assets/api/api.js'
	import {
		menuLoadPrivileges,
		deviceFindUser
	} from '@/assets/api/user.js'
	import treeNode from './node.vue'

	import {
		CampusAnnouncement,
	} from './group/regulatory-platform/index.js' // 监控平台
	import {
		newsSafe,
		ceshi
	} from './group/device-management/index.js' // 设备管理

	import {
		regularitySchool,
		Callrecords,
		Aftersales,
		Electricity,
		Equipment,
		Attendance,
		CommunicationTime,
		Servicehotline,
		Sportsreport,
		Peoplereport,
		Alarmdetail,
		AournalSheet,
		Activeuser,
		Yichang,

	} from './group/Systemreport/index.js' // 统计报表模块
	import {
		RegisteredMember,
	} from './group/registered-member/index.js' // 注册会员管理
	import {
		Uplinklog,
		Downlinklog,
		Entrylog,
		Memberjournal,
		Telecomuplinklog,
		CheckLog
	} from './group/log-management/index.js' // 日志管理
	import {
		// Systemsettings,
		Corporateinformation,
		Officiaimg,
		Railset,
		Smsinterface,
		Rolemanagement,
		Smstypesetting,
		Jwdlongitude,
		Switchsettings,
		Huancunmanagement,
		StealthSettings,
		Usermanagement,
		Locationmanagement,
		healthSettings,
		Locationsettings,
		TimingTracking,
		Shuzimanagement
	} from './group/system-settings/index.js' // 系统设置
	import {
		ManagementSchool,
		StudentGuanli,
		TeatcherGuanli,
		SuSheGuanLi,
		AskariGuanLi
	} from './group/jxt-school-guanli/index' //校园管理
	import {
		SchoolAffiche,
		CheckTongji,
		KaoqinTime,
		KaoqinNote,
		roomCeshi,
		Homework,
		ClassAdmin,
		Anquaneducation,
		ExamKaoshi,
		CheckGuanli,
		CardreaDing, 
		CardreaDingPoint,
		StudentKQ
	} from './group/jxt-teacher-guanli/index' //教务管理
	import {
		stepCountManagement,
		heartRateManagement,
    bodyTemperatureManagement,
    bloodOxygenManagement,
    bloodPressureManagement
	} from './group/health-management/index' //健康管理
	import {
		zuzhiJiagou,
		memberGuanli, 
		gliyuanSettings
	} from './group/old-zzguanli/index' //老人-组织管理
	import {
		jianKang,
		pingTai
	} from './group/old-jiaowu/index' //老人-管理
	import {
		Task,
		Record,
		Tongji,
		Dangan,
		Forms
	} from './group/deyu/index.js' //德育管理

	import {
		StudentManage,
		TeatcherManage,
		TxStrategy
	} from './group/face-mange/index.js' //考勤管理/学生人脸库和教师人脸库

	import {
		LouDong,
		SusheRecord,
		SusheManagement
	} from './group/Sushe/index.js' //宿舍


	export default {
		components: {
			Header, // 导航栏
			CampusAnnouncement, // 校园公告
			newsSafe, // 设备管理
			ceshi,
			regularitySchool, // 报警统计报表
			CommunicationTime, // 通话时长统计
			Callrecords, //通话记录统计
			Aftersales, //'售后管理报表'
			RegisteredMember, //注册会员管理
			Electricity, //电量统计
			Equipment, //设备管理报表
			Attendance, //考勤消息报表
			Servicehotline, //服务热线统计报表
			Sportsreport, //运动报表页面
			Peoplereport, //人员统计报表
			Alarmdetail, //报警详单
			AournalSheet, //日志报表
			Uplinklog, //上行日志
			Downlinklog, //下行日志
			Entrylog, //登录日志
			Memberjournal, //会员日志,
			Telecomuplinklog, //电信上行日志
			Activeuser, //活跃用户统计
			Corporateinformation, //公司信息管理
			Officiaimg, //公众号图片消息回复设置
			Railset, // 围栏设置
			Smsinterface, //短信接口管理
			Rolemanagement, //系统角色管理
			Smstypesetting, //短信类型设置
			Jwdlongitude, //经纬度距离计算
			Switchsettings, //定时开关机设置
			Huancunmanagement, //缓存基站管理
			StealthSettings, //隐身设置
			Usermanagement, //系统用户管理
			Locationmanagement, //定位信息管理
			Locationsettings, //定位接口设置,
			TimingTracking, //定时跟踪设置
			Shuzimanagement, //数字字典设置
			treeNode, // '导航组件'
			Yichang,
			stepCountManagement,//步数管理
			heartRateManagement,//心率管理
			bodyTemperatureManagement,//体温管理
			bloodOxygenManagement,//血氧管理
			bloodPressureManagement,//血压管理
			healthSettings,// 健康设置 

			// 家校通
			ManagementSchool, //学校组织管理
			StudentGuanli, //学生管理
			TeatcherGuanli, //老师管理
			SuSheGuanLi,//宿管管理
			AskariGuanLi,//保安管理
			SchoolAffiche, //学校公告
			CheckGuanli, //考勤管理
			CheckTongji, //考勤统计
			CardreaDing, //读卡器
			CardreaDingPoint, //读卡点
			KaoqinTime, //考勤时间管理
			KaoqinNote, //考勤短信设置
			roomCeshi, //课堂测试
			Homework, //家庭作业
			ClassAdmin,//学科管理
			Anquaneducation, //新闻
			ExamKaoshi, //考试成绩
			CheckLog,
			StudentKQ,
			//老人
			zuzhiJiagou, //组织架构 
			memberGuanli, //成员管理 
			gliyuanSettings, //管理员设置 
			jianKang, //健康管理
			pingTai, //平台公告.

			//德育管理
			Task,
			Record,
			Tongji,
			Dangan,
			Forms,
			
			//考勤管理
			StudentManage,
			TeatcherManage,
			TxStrategy,
			// 宿舍
			LouDong,
			SusheRecord,
			SusheManagement,
		},
		data() {
			return {
				GtsData: {},
				tabList: [{
						name: '大数据平台',
						children: [{
							sonName: '大数据平台',
							// component: '',
							routerUrl: '/screen',
							status: true,
						}, ],
						status: false,
						imgUrl: require('./icons-img/cpt.png'),
					},
					{
						name: '监控平台',
						children: [],
						status: false,
						imgUrl: require('./icons-img/jiankong.png'),
					},
					{
						name: '终端管理',
						status: false,
						imgUrl: require('./icons-img/shebeixiangqing.png'),
						children: [{
								sonName: '终端管理',
								component: 'newsSafe',
								status: false,
							},
							// {
							//   sonName: '设备管理',
							//   component: 'ceshi'
							// },
						],
					},
					{
						name: '学生证管理',
						status: false,
						imgUrl: require('./icons-img/shebeixiangqing.png'),
						children: [{
								sonName: '学生证管理',
								component: 'newsSafe',
								status: false,
							},
						],
					},
					{
						name: '统计报表',
						status: false,
						imgUrl: require('./icons-img/wj-rz.png'),
						children: [
							{
								sonName: '通话时长统计',
								component: 'CommunicationTime',
								status: false,
							},
							{
								sonName: '检测异常统计',
								component: 'Yichang',
								status: true,
							},
							{
								sonName: '通话记录统计',
								component: 'Callrecords',
								status: false,
							},
							{
								sonName: '报警统计报表',
								component: 'regularitySchool',
								status: false,
							},
							{
								sonName: '售后管理报表',
								component: 'Aftersales',
								status: false,
							},

							{
								sonName: '设备管理报表',
								component: 'Equipment',
								status: false,
							},
							{
								sonName: '考勤消息报表',
								component: 'Attendance',
								status: false,
							},
							{
								sonName: '服务热线统计报表',
								component: 'Servicehotline',
								status: false,
							},
							{
								sonName: '报警详单报表',
								component: 'Alarmdetail',
								status: false,
							},
							{
								sonName: '运动计步报表',
								component: 'Sportsreport',
								status: false,
							},
							// {
							//   sonName: '人员统计报表',
							//   component: 'Peoplereport'
							// },
							{
								sonName: '日志报表',
								component: 'AournalSheet',
								status: false,
							},
							{
								sonName: '活跃用户统计',
								component: 'Activeuser',
								status: false,
							},
							{
								sonName: '电量统计',
								component: 'Electricity',
								status: false,
							},
						],
					},
					{
						name: '家长账号管理',
						status: false,
						imgUrl: require('./icons-img/huiyuan.png'),
						children: [{
							sonName: '家长账号管理',
							component: 'RegisteredMember',
							status: false,
						}, ],
					},
					{
						name: '校园管理',
						status: false,
						imgUrl: require('./icons-img/xiaoyuan.png'),
						children: [{
								sonName: '学校组织管理',
								component: 'ManagementSchool',
								status: false,
							},
							{
								sonName: '学生管理',
								component: 'StudentGuanli',
								status: false,
							},
							{
								sonName: '教师管理',
								component: 'TeatcherGuanli',
								status: false,
							},			
							{
								sonName: '宿舍管理员',
								component: 'SuSheGuanLi',
								status: false,
							},
							{
								sonName: '保安管理',
								component: 'AskariGuanLi',
								status: false,
							}
						],
					},
					{
						name: '考勤管理',
						status: false,
						imgUrl: require('./icons-img/kq_control.png'),
						children: [{
								sonName: '考勤记录',
								component: 'CheckGuanli',
								status: false,
							},
							{
								sonName: '考勤统计（日）',
								component: 'CheckTongji',
								status: false,
							},
							{
								sonName: '考勤统计（月）',
								component: 'StudentKQ',
								status: true,
							},
							{
								sonName: '学生人脸图库',
								component: 'StudentManage',
								status: false,
							},
							{
								sonName: '教师人脸图库',
								component: 'TeatcherManage',
								status: false,
							},
							{
								sonName: '读卡器管理',
								component: 'CardreaDing',
								status: false,
							},
							{
								sonName: '读卡点管理',
								component: 'CardreaDingPoint',
								status: false,
							},{
								sonName: '通行策略',
								component: 'TxStrategy',
								status: true,
							},{
								sonName: '考勤时间管理',
								component: 'KaoqinTime',
								status: false,
							},
							{
								sonName: '考勤短信管理',
								component: 'KaoqinNote',
								status: false,
							}
						],
					},
					{
						name: '教务管理',
						status: false,
						imgUrl: require('./icons-img/xuexiao_jiaoshi.png'),
						children: [{
								sonName: '校园公告',
								component: 'SchoolAffiche',
								status: false,
							},
							{
								sonName: '家庭作业',
								component: 'Homework',
								status: false,
							},
							{
								sonName: '学科管理',
								component: 'ClassAdmin',
								status: false,
							},
							{
								sonName: '课堂测试',
								component: 'roomCeshi',
								status: false,
							},
							{
								sonName: '考试成绩管理',
								component: 'ExamKaoshi',
								status: false,
							},
							{
								sonName: '安全教育和新闻',
								component: 'Anquaneducation',
								status: false,
							},
							{
								sonName: '九学王',
								component: '',
								status: false,
							},

						],
					},
					{
						name: '健康管理',
						status: false,
						imgUrl: require('./icons-img/jiankangguanli.png'),
						children: [
							{
								sonName: '步数管理',
								component: 'stepCountManagement',
								status: false,
							},
							{
								sonName: '心率管理',
								component: 'heartRateManagement',
								status: false,
							},
							{
								sonName: '体温管理',
								component: 'bodyTemperatureManagement',
								status: false,
							},
							{
								sonName: '血氧管理',
								component: 'bloodOxygenManagement',
								status: false,
							},
							{
								sonName: '血压管理',
								component: 'bloodPressureManagement',
								status: false,
							},
						],
					},
					//德育
					{
						name: '德育管理',
						status: false,
						imgUrl: require('./icons-img/deyu.png'),
						children: [{
								sonName: '考核任务',
								component: 'Task',
								status: false,
							},
							{
								sonName: '考核记录',
								component: 'Record',
								status: false,

							},
							{
								sonName: '考核统计',
								component: 'Tongji',
								status: false,
							},
							{
								sonName: '德育档案',
								component: 'Dangan',
								status: false,

							},
							{
								sonName: '德育报表',
								component: 'Forms',
								status: false,
							},
						],
					},
					//宿舍管理
					{
						name: '校舍管理',
						status: false,
						imgUrl: require('./icons-img/sushe.png'),
						children: [{
								sonName: '宿舍楼栋',
								component: 'LouDong',
								status: false,
							},
							{
								sonName: '宿舍管理',
								component: 'SusheManagement',
								status: false,

							},
							{
								sonName: '进出记录',
								component: 'SusheRecord',
								status: false,
							},
						],
					},

					{
						name: '日志管理',
						status: false,
						imgUrl: require('./icons-img/shujubaobiao.png'),
						children: [

							{
								sonName: '上行日志',
								component: 'Uplinklog',
								status: false,
							},
							{
								sonName: '下行日志',
								component: 'Downlinklog',
								status: false,
							},

							{
								sonName: '登录日志',
								component: 'Entrylog',
								status: false,
							},

							{
								sonName: '考勤日志',
								component: 'CheckLog',
								status: false,
							},
							// {
							//   sonName: '活跃用户统计',
							//   component: 'Activeuser'
							// },
							// {
							//   sonName: '日志管理',
							//   component: 'Logmanagement'
							// }, 
							// {
							//   sonName: '会员日志',
							//   component: 'Memberjournal'
							// }, 
							// {
							//   sonName: '电信上行日志',
							//   component: 'Telecomuplinklog'
							// }, 

						],
					},
					{
						name: '系统设置',
						status: false,
						imgUrl: require('./icons-img/xitong.png'),
						children: [
							{
							  sonName: '健康设置',
							  component: 'healthSettings',
								status: true,
							},
							{
								sonName: '公司信息管理',
								component: 'Corporateinformation',
								status: false,
							},

							{
								sonName: '围栏设置',
								component: 'Railset',
								status: false,
							},
							{
								sonName: '系统角色管理',
								component: 'Rolemanagement',
								status: false,
							},

							{
								sonName: '定时开关机设置',
								component: 'Switchsettings',
								status: false,
							},
							{
								sonName: '隐身设置',
								component: 'StealthSettings',
								status: false,
							},
							{
								sonName: '系统用户管理',
								component: 'Usermanagement',
								status: false,
							},
							{
								sonName: '定位信息管理',
								component: 'Locationmanagement',
								status: false,
							},
							{
								sonName: '定时跟踪设置',
								component: 'TimingTracking',
								status: false,
							},
							{
								sonName: '数字字典设置',
								component: 'Shuzimanagement',
								status: false,
							},
							// {
							//   sonName: '短信类型设置',
							//   component: 'Smstypesetting'
							// },
							// {
							//   sonName: '经纬度距离计算',
							//   component: 'Jwdlongitude'
							// }, 
							// {
							//   sonName: '公众号图片消息回复设置',
							//   component: 'Officiaimg'
							// },  
							// {
							//   sonName: '短信接口管理',
							//   component: 'Smsinterface'
							// },
							// {
							//   sonName: '缓存基站管理',
							//   component: 'Huancunmanagement'
							// },
							// {
							//   sonName: '定位接口设置',
							//   component: 'Locationsettings'
							// },

						],
					},
					
					// 老年人
					{
						name: '组织管理',
						status: false,
						imgUrl: require('./icons-img/xiaoyuan.png'),
						children: [{
								sonName: '组织架构',
								component: 'zuzhiJiagou',
								status: false,
							},
							{
								sonName: '成员管理',
								component: 'memberGuanli',
								status: false,

							},
							{
								sonName: '管理员设置',
								component: 'gliyuanSettings',
								status: false,
							},
						],
					},
					{
						name: '事务管理',
						status: false,
						imgUrl: require('./icons-img/xuexiao_jiaoshi.png'),
						children: [{
								sonName: '平台公告',
								component: 'pingTai',
								status: false,

							},
							{
								sonName: '健康管理合新闻',
								component: 'jianKang',
								status: false,
							},

						],
					}
					
				],
				currentView: '', // 组件页面
				isCollapse: true,
				locationData: {},
				defaultActive: '', // 1-0 默认展开
				listData: [],
				Cdstatus: false,
				datekey: Date.now(),
				useriTtem: {}
				// Cdstatus: true
			}
		},
		created() {
			this.menuLoadPrivileges()
		},
		mounted() {
			// this.deviceUserDevice()

		},
		methods: {
			skipClick() {
				// console.log(66666666666666);
				window.open('https://beian.miit.gov.cn');
			},

			menuLoadPrivileges() {
				const params = {
					userId: JSON.parse(localStorage.getItem('user')).id,
				}

				menuLoadPrivileges(params).then((res) => {
					this.listData = res.data.data
					console.log(res, '权限111');
					if (this.listData.length) {

						for (let item of this.listData) {
							if (item.name == '监控平台') {
								// 有监管平台 先调客户树
								this.setSystemUserTree()
							}
						}

						// 区分哪些页面 该展示
						for (let item of this.tabList) {
							for (let value of this.listData) {
								if (item.name == value.name) {
									item.status = true
								}
								if (value.name != '监控平台') {
									for (let item2 of item.children) {
										for (let value2 of value.children) {
											if (item2.sonName == value2.name) {
												item2.status = true
											}
										}
									}
								}
							}
						}
						// 接口未返回的页面删除

						for (let i = this.tabList.length - 1; i >= 0; i--) {
							for (let sln = this.tabList[i].children.length - 1; sln >= 0; sln--) {

								if (!this.tabList[i].children[sln].status) {
									this.tabList[i].children.splice(sln, 1)
								}
							}
							if (!this.tabList[i].status) {
								this.tabList.splice(i, 1)
							}
							console.log(this.tabList[i], i);
						}
						for (let i = this.tabList.length - 1; i >= 0; i--) {
							if (!this.tabList[i].children.length && this.tabList[i].name != '监控平台') {
								this.tabList.splice(i, 1)

							}
							//  }
						}


						this.Cdstatus = true
						console.log(this.tabList, '处理后的数组');
					} else {
						console.log('什么都没返回');
						this.$message.error('您暂无权限！');
						this.$router.push({
							path: `/login`
						})

					}
					// this.Cdstatus = true  
				}).catch((err) => {
					console.log(err, '22222');

				})
			},
			deviceUserDevice(item) {
				// console.log(item,'史丽娜查看');
				item.zhuangtai = true
				let params = {
					userId: item.id,
				}
				deviceUserDevice(params).then((res) => {
					console.log(res, '查询用户下的设备--接口');
					if (item.children) {
						item.children = [...item.children, ...res.data.data]
					} else {
						item.children = res.data.data
					}
				}).catch((err) => {
					console.log(err);
				})
			},
			setSystemUserTree() {
				let params = {
					userId: JSON.parse(localStorage.getItem('user')).id,
				}
				setSystemUserTree(params).then((res) => {
					console.log(res, '用户树--接口');
					const arr = res.data.data
					this.walk(arr)
					for (let item of this.tabList) {
						if (item.name == '监控平台') {
							//有监管平台·先调客户树
							item.children = arr
						}

					}
					// this.tabList[0].children = arr

					if (this.$route.query.imei) {
						//跳转到指定界面
						this.handleOpendw(arr[0])

					}
				}).catch((err) => {
					console.log(err);
				})
			},
			walk(arr) {
				if (!Array.isArray(arr)) {
					return
				}
				arr.forEach(element => {
					if (element.deviceId) {
						return
					}
					// if (!element.children) {
					//   element.children = [...element.userDevices]
					// } else {
					//   element.children = [...element.children, ...element.userDevices]
					// }
					if (Array.isArray(element.children) && element.children.length) {
						this.walk(element.children)
					}
				})
			},
			handleOpendw(item) {
				console.log("🚀 ~ handleOpendw ~ item:", item)
				this.useriTtem = item
				this.locationData = {}
				if (item.deviceId || item.id) {
					console.log('我是用户的userid', item.id);
					this.currentView = 'CampusAnnouncement'
					if (item.deviceId) {
						this.locationData = item
						console.log(444, '单个', item);
					} else if (item.id) {
						if (!item.zhuangtai) {
							this.deviceUserDevice(item)
						}
						this.getGtslocation(item)
						console.log(555, '群体', item);
					}
				} else if (item.component) {
					this.currentView = item.component
					this.datekey = Date.now()
					console.log('组件页面');
				} else if (item.routerUrl) {

					// routerUrl
					this.$router.push({
						path: item.routerUrl
					})
				} else {
					// this.$message({
					//   message: '该模块正在开发中',
					//   type: 'warning'
					// });
				}
				console.log(this.currentView)
			},
			// 查找用户下的设备位置
			getGtslocation(item) {
				// console.log(item.id,'史丽娜获取用户userid');
				const params = {
					userId: item.id
				}
				deviceFindUser(params).then((res) => {
					this.GtsData = res.data
					console.log(this.GtsData, '群体位置成功', );

				}).catch((err) => {
					console.log(err, '失败');
				})
			},
			// xialkuang (item) {
			//   // for ( let value of this.tabList ) {
			//   //     value.status = false
			//   //   }
			//   item.xialkuang = true
			//   console.log( this.tabList );
			// },
			// handleSelect(key, keyPath) {
			//   console.log(key, keyPath,'选择单个');
			// },

			handleOpen(key, keyPath) {
				console.log(key, keyPath, '外层展开')
			},
			handleClose(key, keyPath) {
				console.log(key, keyPath);
			}
		}
	}
</script>

<style lang='scss' scoped>
	/deep/ {
		.el-menu-vertical-demo-item:nth-child(1)>.el-sub-menu {
			li {
				max-height: 400px !important;
				overflow: hidden auto !important;
			}
		}
	}

	.bidding-system {
		width: 100%;
		height: 100vh;
		background-color: #fff;
		position: relative;

		.headerBox {
			height: 70px;
			// position: fixed;
			// left: 240px;
			z-index: 15;
		}

		.left-navigation {

			// position: absolute;
			height: calc(100vh - 80px);
			// box-shadow: 5px 5px 20px 0px rgba(0, 0, 0, 0.1);
			// z-index: 6;
			// display: inline-block;
			// padding-top: 80px;
			overflow: auto;
			// background-color: ;

			/deep/ {
				.el-menu .el-menu--vertical .el-menu-vertical-demo {
					// background-color: #E0ECFF;
					// font-weight: 700 !important;

				}

				.el-menu-item.is-active {
					// color:#349AFD;
					color: #fff;
					font-size: 14px !important;
					// font-weight: 600;
					background-color: #459FFC,

				}

				.el-menu {
					// margin-top: 20px;
					// height: calc(100vh - 70px) ;
					width: 240px;
					border: 0px;
				}

				.tupian {
					position: absolute;
					left: 25px;
					width: 15px;
					height: 15px;
					// background-image: url(./im/ages/fuzzyMatchingImg.png);
					background-repeat: no-repeat;
					background-size: 100% 100%;
				}

				.navigation-center {
					// margin: auto;
					position: absolute;
					left: 55px;
					font-size: 16px;
				}

				.el-sub-menu .el-sub-menu__icon-arrow {
					right: 40px;
				}

				.el-icon svg {
					// width: 15px;
				}

				.el-sub-menu {
					// font-weight: 700;
					font-size: 16px;
				}

				.el-menu .el-menu--inline {
					font-weight: 400;
				}

				.el-sub-menu__title span {
					font-weight: 700 !important;
					font-size: 16px;
					// background-color: pink;
				}
			}
		}

		.left-navigation-isCollapse {
			width: 50px;

			// }
			/deep/ {
				.el-menu {
					width: 50px;
					border: 0px;
				}
			}
		}


		.el-menu {
			// background-color: #E0ECFF !important;

		}

		.right-page {
			position: absolute;
			left: 240px;
			top: 69px;
			padding: 30px 30px;
			padding-bottom: 0px;
			width: calc(100% - 240px);
			height: calc(100vh - 70px);
			background-color: #F4F7FC;

		}

		.right-page-isCollapse {
			left: 50px;
			width: calc(100% - 50px);
		}

		.beijing-img {
			position: absolute;
			left: 240px;
			top: 70px;
			padding-bottom: 0px;
			width: calc(100% - 240px);
			height: calc(100vh - 70px);
			background-image: url(./images/beijing.jpg);
			background-repeat: no-repeat;
			// background-size: cover;
			background-color: #F4F7FC;
			// background-color: #f1f1f1 ;
			background-size: 96% 94%;
			background-position: center center;
			// border:3px solid red;
			// background-color: #f1f1f1; box-shadow: 0 0 10px rgba(0, 0, 0, 0.5);
		}

		.beijing-beian {
			// margin-left: 550px;
			// margin-top: 10px;
			color: #2C9DF7;
			font-size: 15px;
			position: absolute;
			left: 50%;
			bottom: 10px;
		transform: translate(-50%,0px);
			// padding-top: 0px;
		}

		.beian {
			margin-left: 550px;
			// margin-top: 10px;
			color: #2C9DF7;
			font-size: 14px;
			margin-top: 5px;

		}
	}

	.el-menu-vertical-demo:not(.el-menu--collapse) {
		width: 240px;
	}
</style>